import {Injectable} from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {SharedService} from "./sharedService";
import {Observable, of} from "rxjs";
import {PagerDataObject} from "../entities/pagerDataObject";
import {catchError, map, tap} from "rxjs/operators";
import {Report} from "../entities/report";

const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable()
export class ReportService {

    constructor(private http: HttpClient,
                private sharedService: SharedService) {}

    getData$(id: any,query: string): Observable<PagerDataObject> {
        return this.http.get<PagerDataObject>(this.sharedService.apiUrl(`api/reports/${id}/data`, query !== null ? ("/" + query) : ""))
    }

    // export$(id: any, query: string): Observable<PagerDataObject> {
    //     return this.http.get<PagerDataObject>(this.sharedService.apiUrl(`api/reports/${id}/export`, query !== null ? ("/" + query) : ""))
    // }

    export$(query): Observable<Blob> {

        const httpOptionsExcel = {
            headers: new HttpHeaders({ 'Accept': 'application/vnd.ms-excel', 'Content-Type': 'application/vnd.ms-excel' }),
            responseType: 'blob' as 'json'
        };
        return this.http.get<any>(this.sharedService.apiUrl('api/reports/export?', query), httpOptionsExcel).pipe(
            map((res: Response) => res), catchError(this.sharedService.handleError<any>('download excel'))
        )}

    getReportList(): Observable<any> {
        return this.http.get<PagerDataObject>(this.sharedService.apiUrl('api/reports/list', ""));
    }

    upsert$(report: Report): Observable<Report> {
        return this.http.post<Report>(this.sharedService.apiUrl('api/reports/upsert'), report, httpOptions).pipe(
            catchError(this.sharedService.handleError<any>('add'))
        );
    }

    getReport(id: string): Observable<Report> {
        return this.http.get<Report>(this.sharedService.apiUrl(`api/reports/${id}`))
    }

    runReport(report: Report): Observable<Report> {
        return this.http.post<Report>(this.sharedService.apiUrl('api/reports/run-report'), report, httpOptions).pipe(
            catchError(this.sharedService.handleError<any>('report'))
        );
    }

    getReportResult(query: string): Observable<PagerDataObject> {
        return this.http.get<PagerDataObject>(this.sharedService.apiUrl('api/reports/result', query !== null?(query):""))
    }

    delete(id: any): Observable<Report> {
        return this.http.delete<any>(this.sharedService.apiUrl('api/reports', id), httpOptions).pipe(
            catchError(this.sharedService.handleError<any>('deleteReport'))
        );
    }

}
